<template>
  <v-card class="elevation-12">
    <v-card-title class="px-9 pt-7">
      <v-row class="py-0">
        <v-col
          class="py-0"
        >
          {{ title ? title : '' }}
        </v-col>
        <v-col class="py-0 text-right">
          EAN {{ data.ean ? data.ean : '' }}
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text
      v-if="data.allowedInstallationAction ?
        data.allowedInstallationAction.name === 'READING' : false"
      class="px-9"
    >
      <v-alert type="info">
        {{ data.allowedInstallationAction.localizedText }}
      </v-alert>
    </v-card-text>

    <v-card-text
      v-else
      class="px-9"
    >
      <v-row>
        <v-col
          cols="12"
          class="text-body-1"
        >
          <v-row>
            <v-col cols="6">
              Obchodní partner
              <br>
              <span class="font-weight-bold">
                <template v-if="data.partner">
                    {{ data.partner }}
                    <br v-if="data.taxNumber" />
                    {{ data.taxNumber ? `IČO ${data.taxNumber}` : '' }}
                </template>

                <template v-else>
                  {{ `${data.firstName} ${data.lastName}` }}
                </template>
              </span>
            </v-col>

            <v-col cols="6">
              Adresa
              <br />
              <span
                v-if="data"
                class="font-weight-bold"
              >
                {{
                  `${data.street} ${data.houseNumber}` +
                  (data.houseNumber2 ? `/${data.houseNumber2}` : '')
                }}
                <br />
                {{ `${data.city}, ${data.district} ${data.postCode}`}}
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row v-if="detailType === 'changeOfReservedCapacity'">
        <v-col>
          {{ data.changeOfReservedCapacityInfo }}
        </v-col>
      </v-row>
    </v-card-text>

    <div
      v-if="detailType === 'collectionPoint' && data && data.status"
      style="background-color: rgb(183, 15, 10);"
      class="px-8 py-3"
    >
      <v-icon class="white--text">
        mdi-alert
      </v-icon>
      <span class="white--text ml-3 font-italic">
        {{ data.status.localizedText }}
      </span>
    </div>
  </v-card>
</template>

<script>

export default {
  name: 'CollectionPointHeaderCard',
  props: {
    title: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    detailType: {
      type: String,
      default: '',
    },
  },
};
</script>
